var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 596,
    height: 126,
    viewBox: "0 0 596 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6875 39.375C30.5606 39.375 39.375 30.5606 39.375 19.6875C39.375 8.81439 30.5606 0 19.6875 0C8.81439 0 0 8.81439 0 19.6875C0 30.5606 8.81439 39.375 19.6875 39.375ZM19.6875 39.375H23.625V126H15.75V39.375H19.6875Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.688 39.375C166.561 39.375 175.375 30.5606 175.375 19.6875C175.375 8.81439 166.561 0 155.688 0C144.814 0 136 8.81439 136 19.6875C136 30.5606 144.814 39.375 155.688 39.375ZM155.688 39.375H159.625V126H151.75V39.375H155.688Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.688 39.375C286.561 39.375 295.375 30.5606 295.375 19.6875C295.375 8.81439 286.561 0 275.688 0C264.814 0 256 8.81439 256 19.6875C256 30.5606 264.814 39.375 275.688 39.375ZM275.688 39.375H279.625V126H271.75V39.375H275.688Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.688 39.375C406.561 39.375 415.375 30.5606 415.375 19.6875C415.375 8.81439 406.561 0 395.688 0C384.814 0 376 8.81439 376 19.6875C376 30.5606 384.814 39.375 395.688 39.375ZM395.688 39.375H399.625V126H391.75V39.375H395.688Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M515.688 39.375C526.561 39.375 535.375 30.5606 535.375 19.6875C535.375 8.81439 526.561 0 515.688 0C504.814 0 496 8.81439 496 19.6875C496 30.5606 504.814 39.375 515.688 39.375ZM515.688 39.375H519.625V126H511.75V39.375H515.688Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86 64.4C93.732 64.4 100 58.132 100 50.4C100 42.668 93.732 36.4 86 36.4C78.268 36.4 72 42.668 72 50.4C72 58.132 78.268 64.4 86 64.4ZM86 64.4H88.8V126H83.2V64.4H86Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222 64.4C229.732 64.4 236 58.132 236 50.4C236 42.668 229.732 36.4 222 36.4C214.268 36.4 208 42.668 208 50.4C208 58.132 214.268 64.4 222 64.4ZM222 64.4H224.8V126H219.2V64.4H222Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342 64.4C349.732 64.4 356 58.132 356 50.4C356 42.668 349.732 36.4 342 36.4C334.268 36.4 328 42.668 328 50.4C328 58.132 334.268 64.4 342 64.4ZM342 64.4H344.8V126H339.2V64.4H342Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M462 64.4C469.732 64.4 476 58.132 476 50.4C476 42.668 469.732 36.4 462 36.4C454.268 36.4 448 42.668 448 50.4C448 58.132 454.268 64.4 462 64.4ZM462 64.4H464.8V126H459.2V64.4H462Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M582 64.4C589.732 64.4 596 58.132 596 50.4C596 42.668 589.732 36.4 582 36.4C574.268 36.4 568 42.668 568 50.4C568 58.132 574.268 64.4 582 64.4ZM582 64.4H584.8V126H579.2V64.4H582Z",
    fill: "#FBFBFB"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.4fb1f7c4319ab68d2f4e8894fbe25f83.svg";
export { ForwardRef as ReactComponent };